import { render, staticRenderFns } from "./Requerimiento.vue?vue&type=template&id=2918d060"
import script from "./Requerimiento.vue?vue&type=script&lang=js"
export * from "./Requerimiento.vue?vue&type=script&lang=js"
import style0 from "./Requerimiento.vue?vue&type=style&index=0&id=2918d060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports